import { chiliMixpanel } from './chili-mixpanel'

export const chiliTrack = {
  mixpanel: chiliMixpanel,
}
